<script>
  /**
   * 横田工業 作業記録 入力ダイアログ
   *  - await show() で表示でき、返り値に入力した記録を返す
   */
  import { YOKOTA_LOG_SCHEME } from '../../scheme'

  import CheckboxInput from '../googleForm/CheckboxInput.svelte'
  import NumberInput from './inputs/NumberInput.svelte'
  import ModalCard from '../ModalCard.svelte'
  import SchemaFieldRenderer from '../googleForm/SchemaFieldRenderer.svelte'

  const idPrefix = 'YokotaLogDialog'

  export let memberList

  let value
  let modal // モーダル保持用
  let resolvePromise // モーダルが閉じたことを通知するための promise
  let chosenMemberList = [] // 選択済みのメンバー。都度の初期化はせず続けて入力しやすくする。
  let hours // 作業時間

  // ローカル変数の初期化
  const init = () => {
    value = { projectCode: '73-' }
    hours = undefined
  }

  init()

  export function show() {
    init()
    modal.show()
    return new Promise(resolve => {
      resolvePromise = resolve
    })
  }

  const confirmHandler = () => {
    // 選択されたメンバーに作業時間を割り当てる
    const intHours = parseInt(hours)
    value.hours = chosenMemberList.reduce((acc, member) => {
      acc[member] = intHours
      return acc
    }, {})

    resolvePromise(value)
    return true
  }

  // キャンセルボタンを押したらプロミスを解消しておく
  const cancel = () => resolvePromise()
</script>

<ModalCard
  title="作業時間 入力"
  {confirmHandler}
  on:cancel={cancel}
  bind:this={modal}
>
  <!-- スキーマを元に入力欄を作成 -->
  {#each YOKOTA_LOG_SCHEME as field}
    {@const { name, type } = field}
    {@const id = `${idPrefix}-${name}`}
    {#if type}
      {#if type === 'checkbox'}
        <!-- チェックボックスは checked を bind する -->
        <SchemaFieldRenderer {id} {field} bind:checked={value[name]} />
      {:else}
        <SchemaFieldRenderer {id} {field} bind:value={value[name]} />
      {/if}
    {/if}
  {/each}

  <!-- 作業メンバー チェックボックス -->
  <CheckboxInput
    id={`${idPrefix}-members`}
    name="member"
    label="作業者"
    values={memberList}
    style="zoom: 1.25;"
    bind:checked={chosenMemberList}
  />

  <!-- 選択解除/全員選択 ボタン -->
  <button
    type="button"
    class="button is-warning"
    data-testid={`deselectAllMembers`}
    on:click={() => {
      chosenMemberList = []
    }}>選択解除</button
  >
  <button
    type="button"
    class="button is-info"
    data-testid={`selectAllMembers`}
    on:click={() => {
      chosenMemberList = [...memberList]
    }}>全員選択</button
  >

  <!-- 作業時間 入力欄 -->
  <NumberInput
    id={`${idPrefix}-hours`}
    name="hours"
    label="作業時間"
    min="1"
    max="8"
    step="1"
    bind:value={hours}
  />
</ModalCard>
